import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../style/gibraltar.css';

// Importing images for Lithuania (1-36)
import lithuania1 from '../images/lithuania1.jpeg';
import lithuania2 from '../images/lithuania2.jpeg';
import lithuania3 from '../images/lithuania3.jpeg';
import lithuania4 from '../images/lithuania4.jpeg';
import lithuania5 from '../images/lithuania5.jpeg';
import lithuania6 from '../images/lithuania6.jpeg';
import lithuania7 from '../images/lithuania7.jpeg';
import lithuania8 from '../images/lithuania8.jpeg';
import lithuania9 from '../images/lithuania9.jpeg';
import lithuania10 from '../images/lithuania10.jpeg';
import lithuania11 from '../images/lithuania11.jpeg';
import lithuania12 from '../images/lithuania12.jpeg';
import lithuania13 from '../images/lithuania13.jpeg';
import lithuania14 from '../images/lithuania14.jpeg';
import lithuania15 from '../images/lithuania15.jpeg';
import lithuania16 from '../images/lithuania16.jpeg';
import lithuania17 from '../images/lithuania17.jpeg';
import lithuania18 from '../images/lithuania18.jpeg';
import lithuania19 from '../images/lithuania19.jpeg';
import lithuania20 from '../images/lithuania20.jpeg';
import lithuania21 from '../images/lithuania21.jpeg';
import lithuania22 from '../images/lithuania22.jpeg';
import lithuania23 from '../images/lithuania23.jpeg';
import lithuania24 from '../images/lithuania24.jpeg';
import lithuania25 from '../images/lithuania25.jpeg';
import lithuania26 from '../images/lithuania26.jpeg';
import lithuania27 from '../images/lithuania27.jpeg';
import lithuania28 from '../images/lithuania28.jpeg';
import lithuania29 from '../images/lithuania29.jpeg';
import lithuania30 from '../images/lithuania30.jpeg';
import lithuania31 from '../images/lithuania31.jpeg';
import lithuania32 from '../images/lithuania32.jpeg';
import lithuania33 from '../images/lithuania33.jpeg';
import lithuania34 from '../images/lithuania34.jpeg';
import lithuania35 from '../images/lithuania35.jpeg';
import lithuania36 from '../images/lithuania36.jpeg';

function Lithuania() {
  const navigate = useNavigate();
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  // Array of all imported images
  const photos = [
    lithuania1, lithuania2, lithuania3, lithuania4, lithuania5, lithuania6, lithuania7, lithuania8, lithuania9, lithuania10,
    lithuania11, lithuania12, lithuania13, lithuania14, lithuania15, lithuania16, lithuania17, lithuania18, lithuania19, lithuania20,
    lithuania21, lithuania22, lithuania23, lithuania24, lithuania25, lithuania26, lithuania27, lithuania28, lithuania29, lithuania30,
    lithuania31, lithuania32, lithuania33, lithuania34, lithuania35, lithuania36
  ];

  // Function to handle image click
  const handleImageClick = (index) => {
    setSelectedImageIndex(index);
  };

  // Function to close the modal
  const closeModal = () => {
    setSelectedImageIndex(null);
  };

  // Function to navigate to the previous image
  const goToPrevious = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === 0 ? photos.length - 1 : prevIndex - 1
    );
  };

  // Function to navigate to the next image
  const goToNext = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === photos.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="gibraltar-page">
      <h1>🇱🇹 Lithuania 2019 🇱🇹</h1>
      <button className="back-button" onClick={() => navigate(-1)}>
        &larr; 
      </button>

      <div className="photo-grid">
        {photos.map((photo, index) => (
          <div
            key={index}
            className="photo-item"
            onClick={() => handleImageClick(index)}
          >
            <img src={photo} alt={`Lithuania ${index + 1}`} />
          </div>
        ))}
      </div>

      {/* Modal for displaying the larger image */}
      {selectedImageIndex !== null && (
        <div className="modal" onClick={closeModal}>
          <div className="modal-content">
            <button className="arrow left-arrow" onClick={(e) => { e.stopPropagation(); goToPrevious(); }}>
              &larr;
            </button>
            <img
              src={photos[selectedImageIndex]}
              alt="Selected"
              className="modal-image"
            />
            <button className="arrow right-arrow" onClick={(e) => { e.stopPropagation(); goToNext(); }}>
              &rarr;
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Lithuania;